import { Component, OnInit, Inject } from "@angular/core";
import { DataService } from "../shared/services/data.service";
import { MatLegacyDialog as MatDialog, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { SupportedBrowsersResponse } from "../model/supported-browsers-response.model";

@Component({
  selector: "app-unsupported-browser-alert",
  templateUrl: "./unsupported-browser-alert.component.html",
  styleUrls: ["./unsupported-browser-alert.component.scss"],
})
export class UnsupportedBrowserAlertComponent {
  supportBrowsersResp: SupportedBrowsersResponse;

  constructor(
    private dataService: DataService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.supportBrowsersResp = data;
  }
}
